






































import { Component, Vue } from "vue-property-decorator";
import EnduserQuestionnaireExplorer from "@/components/EnduserQuestionnaireExplorer.vue";
import CreditsViewer from "@/components/CreditsViewer.vue";
import ResumeManager from "@/components/ResumeManager.vue";
import NormatifQuestionnaireExplorer from "@/components/NormatifQuestionnaireExplorer.vue";
import axios from "axios";
import { mapGetters } from "vuex";

axios.defaults.baseURL = process.env.BASE_URL;

@Component({
  components: { EnduserQuestionnaireExplorer, ResumeManager, CreditsViewer, NormatifQuestionnaireExplorer },
  computed: mapGetters(["getUser"])
})
export default class DashboardEnduser extends Vue {
  getUser: any;

  mounted(){
    if(this.$route.query['test-send-success']){
      this.$toast.success("Merci ! Votre test a bien été envoyé.")
    }
  }
}
